import React, { Component } from 'react';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {connect} from 'react-redux';
import swal from '@sweetalert/with-react'
import { icon } from '@fortawesome/fontawesome-svg-core';
import {uploadPOVersionFile} from '../store/actions/fileActions.js'

class PoDocumentRevisePopUp extends React.Component {
    constructor(props){
        super(props);
        this.state ={
            showRevisedPopUp:this.props.OpenVersionUploadPopUp,
            revisedPayload:this.props.revisedPayload,
            selectedfilestageIdVersion:[],//Keep documentTypeId
            poRowData:this.props.poRowData,
            file:"",
            comment:""
        }
    }

    componentWillMount(){
        
    }

    dateformate(dateVal){
        let d = new Date(dateVal);
        return d.toDateString();
    }

    revisePopUpAction(st){
        this.props.OpenSaveVersionFilePopUp(null,true)
    }

    formSaveAction = async ()=>{
        if(!this.state.file){
            swal("Please select a valid document",{icon:"error"}) 
        }
        swal("Revise document is uploading...",{icon:"info",button:false});
        await this.props.uploadPOVersionFile(this.state.file,this.state.comment,this.state.poRowData.uploadId,this.state.poRowData.PoDocumentId);
        
        this.revisePopUpAction(false);
    }

    handleFileInput =(event)=>{
        let file = event.target.files[0]
        this.setState({file});
    }

    formChange = (e)=>{
        let comment = e.target.value;
        this.setState({comment});
    }



    

    render(){
        
        return(
            this.state.showRevisedPopUp && <Modal isOpen={this.state.showRevisedPopUp} >
                <div className={"modal-bg" + (this.state.showRevisedPopUp == true  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header">
                            <div className="modal-text"><h4 >Upload New Version</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={(e)=>this.revisePopUpAction(false)} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <div>
                        <ModalBody Style="modal-body modalbodys">

                                <div className="row ">
                                    <div className="col-8"></div>
                                    <div className="col-4 pb-2">
                                        {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                    </div>
                                </div> 
                                
                                <div className="row col-sm-12" style={{textAlign:"center",display:"none",top:"40%"}}>
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>

                                <div className="row ">
                                    <div className="col-sm-6">
                                        Upload Revise Document (Required)
                                    </div>
                                    <div className="col-sm-6">
                                        <input type="file" className="form-control-file" name="upload" onChange={(e) => {this.handleFileInput(e)}} id="exampleFormControlFile2"/>
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-sm-6">
                                        Comment
                                    </div>
                                    <div className="col-sm-6">
                                        <textarea className="form-control" onChange={(e)=>this.formChange(e)} value={this.state.comment}></textarea>
                                    </div>
                                </div>
                                

                                <div>
                                </div>    
                                
                                  
                        </ModalBody>
                    </div>
                    <div className="">    
                        <ModalFooter FooterStyle="modal-footer">
                            <div>
                                <button className="btn2 btn-sms1 mt-2 ml-2 float-right"  onClick={()=>this.formSaveAction()}type="submit">Save</button> 
                                <button className="btn2 btn-sms1 mt-2 ml-2 " onClick={()=>this.revisePopUpAction(false)} type="submit">Close</button> 
                                
                            </div>
                        </ModalFooter>
                    </div>
            </div>
            </Modal>
   
        )
    }
}

const mapStateToProps  = (state) => ({ 
})
export default connect(mapStateToProps, {uploadPOVersionFile})(PoDocumentRevisePopUp)